import $ from 'jquery';
import HttpUtil from './httpUtil';
import RequestUrl from '../commonjs/urlConfiger';
 export default {
  /**
   * 发送PB的方法
   * http 接口地址
   * obj 传递的参数
   */
   postSendPB(http,obj){
     HttpUtil.post(http,JSON.stringify(obj),{'Content-Type':'application/json; charset=UTF-8'}).then((json) => {
       console.log(json);
     });
   },
   getSendPB(http,obj){
     HttpUtil.get(http).then((json) => {
       console.log(json);
     });
   },
   getValue(val){//获取地址栏参数 val为键值
       let data = new RegExp("(^|&)" + val + "=([^&]*)(&|$)", "i");
       let value = window.location.search.substr(1).match(data);
       if ( value != null ){
          return decodeURI(value[2]);
       }else{
          return null;
       }
   },
   setCookie(name, value, expiredays){//设置Cookie有效期
       let exdate = new Date();
　　　　exdate.setDate(exdate.getDate() + expiredays);
       document.cookie = name + "=" + escape(value) + ((expiredays==null) ? "" : ";expires="+exdate.toGMTString());
   },
   getCookie(name){//获取Cookie
       let arr,reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
       return (arr = document.cookie.match(reg)) ? unescape(arr[2]) : null;
   },
   delCookie(name){//删除Cookie
       let exp = new Date();
       exp.setTime(exp.getTime() - 1);
       let cval = this.getCookie(name);
       if(cval != null) document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
   }
}



// WEBPACK FOOTER //
// ./src/commonjs/method.js